import { render, staticRenderFns } from "./BeneficiariesList.vue?vue&type=template&id=8dad61b2&"
import script from "./BeneficiariesList.vue?vue&type=script&lang=js&"
export * from "./BeneficiariesList.vue?vue&type=script&lang=js&"
import style0 from "./BeneficiariesList.vue?vue&type=style&index=0&id=8dad61b2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports